import { FilterStatePropertyValue } from '../../../../api/filterTypes';
import { PredicateClause, SearchComparison, SearchPredicate } from '../../../../api/searchApiTypes';

export const stringPropClauseResolver = <T>(property: keyof T, propertyValue: FilterStatePropertyValue): PredicateClause<T> => ({
  clauses: propertyValue.value.map(pv => ({ condition: { property, comparison: SearchComparison.Eq, argument: pv } })),
  predicate: SearchPredicate.Or,
});
